import {takeEvery, put, call, all, fork} from "redux-saga/effects"

import {
  ENUM_VERSIONS_LIST
} from "./actionTypes"
import {
  enumVersionsListSuccess,
  enumVersionsListError
} from "./actions"

import {
  apiGetEnumVersionsList,
} from "../../../api/calls/enums/versions"

function* enumVersionsList({payload: data}) {
  try {
    const response = yield call(apiGetEnumVersionsList, data)
    yield put(enumVersionsListSuccess(response))
  } catch (error) {
    yield put(enumVersionsListError(error))
  }
}

export function* watchEnumVersionsList() {
  yield takeEvery(ENUM_VERSIONS_LIST, enumVersionsList);
}

function* enumVersionsSaga() {
  yield all([
    fork(watchEnumVersionsList),
  ]);
}

export default enumVersionsSaga
